import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07d24fd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-box" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_date_picker, {
      class: "search-item",
      size: "small",
      modelValue: _ctx.orderState.searchOptions.submit_time,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderState.searchOptions.submit_time) = $event)),
      format: "YYYY-MM-DD HH:mm:ss",
      "value-format": "YYYY-MM-DD HH:mm:ss",
      type: "datetimerange",
      "default-time": _ctx.defaultTime,
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    }, null, 8, ["modelValue", "default-time"]),
    _createVNode(_component_el_input, {
      class: "search-item",
      size: "small",
      modelValue: _ctx.orderState.searchOptions.mobile_number,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderState.searchOptions.mobile_number) = $event)),
      maxlength: "11",
      placeholder: "预约手机",
      clearable: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_button, {
      size: "small",
      type: "primary",
      onClick: _ctx.handleSearchBtnClick
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_button, {
      size: "small",
      color: "#fff",
      style: {"color":"#000","border":"1px solid #bfc5d9"},
      onClick: _ctx.handleResetSearchOptions
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}